// ink-component
import React, { ReactNode } from 'react';

import useDeprecatedWarning from '../../../hooks/useDeprecatedWarning';
import getGlobalProps from '../../../helpers/constants/global-props';

import TableBodyRow from '../TableBodyRow/TableBodyRow';

type Ribbon = {
  text: string;
  color: 'green' | 'red' | 'blue' | 'orange' | 'yellow' | 'gray' | 'purple' | 'pink';
};

export interface TableTwiddleRowProps {
  /** Contents that will be hidden/shown by the twiddle */
  children?: ReactNode;
  /** Type of the row ribbon */
  ribbon?: string | Ribbon;
  /** Row indentation */
  indent?: 1 | 2 | 3 | 4;
  /** Color of the row stripe */
  stripe?: 'blue' | 'brown' | 'grey' | 'green' | 'pink';
  /** Modifier for shaded rows */
  shaded?: boolean;
  /** The row that will be clickable to toggle the twiddle behavior,
   * usually consists of a TableBodyRow with TableCells inside */
  trigger?: ReactNode;
  /** Changes the highlights of the Row */
  highlight?: 'blue' | 'green' | 'red' | 'yellow';
  /** Props for external state control of the twiddle */
  isOpen?: boolean;
  /** onClick callback for the row. It will not be called if the content of the
   * row is editable - such as Inputs or Select components */
  onClick?: () => void;

  /** @ignore */
  rowIndex?: number;
}

const globalProps = getGlobalProps({ deprecated: true });

/**
 * @categories table
 * @purpose Wraps cells to create an expandable row inside the table body
 * @deprecated This component is deprecated and replaced by [NewTable.Twiddle](https://ink.carta.com/components/NewTableTwiddle/)
 * @status deprecated
 * @replacementComponent NewTable.Twiddle
 * @dateOfDeletion December 1st, 2023
 */
function TableTwiddleRow(props: TableTwiddleRowProps) {
  useDeprecatedWarning({ componentName: 'TableTwiddleRow', substitute: 'NewTable.Twiddle' });

  return <TableBodyRow {...props} twiddle {...globalProps} />;
}

TableTwiddleRow.defaultProps = {
  children: undefined,
  ribbon: undefined,
  indent: undefined,
  stripe: undefined,
  shaded: undefined,
  trigger: undefined,
  highlight: undefined,
  isOpen: false,
  onClick: undefined,
};

TableTwiddleRow.displayName = 'TableTwiddleRow';

export default TableTwiddleRow;
